export const Version = "v0.10.14-prod";
// file will be OVERWRITTEN by "update-version"
